import clsx from 'clsx';
import React from 'react';
import SearchArea from '../../../list/components/search-area/SearchArea';
import styles from './GlobalSearchHeader.module.scss';
import { GlobalSearchEntityFilter } from '../GlobalSearchEntityFilter/GlobalSearchEntityFilter';
import { useGlobalSearchContext } from '../../hooks/useGlobalSearchContext';

export function GlobalSearchHeader() {
  const {
    onSearch,
    showBody,
    searchAreaRef
  } = useGlobalSearchContext();

  return (
    <>
      <div
        className={
        clsx(
          'w-100 px-5 pt-5 mb-5 position-relative',
          !showBody && 'border-bottom-0',
          styles.globalSearchHeader
        )}
      >
        <SearchArea
          dataId='global-search'
          autofocus
          onSearch={onSearch}
          placeholder='Search Anything'
          collapsible={false}
          debounceInterval={300}
          wrapperClassName='w-100'
          onRefUpdate={ref => {
            // @ts-ignore
            searchAreaRef.current = ref;
          }}
        />
      </div>

      <span className='text-secondary text-normal pl-5 pb-3'>Looking for...</span>

      <div className='center-flex-row overflow-auto flex-wrap gap-1 px-5 mb-4 mt-2'>
        <GlobalSearchEntityFilter />
      </div>
    </>
  );
}
